module.exports = __webpack_public_path__ + "img/diner.188ed13.svg";